﻿document.addEventListener("DOMContentLoaded", function () {
    var lazyloadImages;

    if ("IntersectionObserver" in window && false) {
        lazyloadImages = document.querySelectorAll(".lazy");
        var imageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var image = entry.target;

                    image.classList.remove("lazy");
                    image.style.backgroundImage = `url('${image.dataset.backgroundImageUrl}')`;
                    imageObserver.unobserve(image);
                }
            });
        });

        lazyloadImages.forEach(function (image) {
            imageObserver.observe(image);
        });
    } else {
        function inViewport(element) {
            if (!element) return false;
            if (1 !== element.nodeType) return false;

            var html = document.documentElement;
            var rect = element.getBoundingClientRect();

            return !!rect &&
                rect.bottom >= 0 &&
                rect.right >= 0 &&
                rect.left <= html.clientWidth &&
                rect.top <= html.clientHeight;
        }

        var lazyloadThrottleTimeout;
        lazyloadImages = document.querySelectorAll(".lazy");
        
        function lazyload() {
            if (lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }

            lazyloadThrottleTimeout = setTimeout(function () {
                lazyloadImages.forEach(function (image) {
                    
                    if (inViewport(image)) {
                        image.classList.remove("lazy");
                        image.style.backgroundImage = `url('${image.dataset.backgroundImageUrl}')`;
                    }
                });
                if (lazyloadImages.length == 0) {
                    document.removeEventListener("scroll", lazyload);
                    window.removeEventListener("resize", lazyload);
                    window.removeEventListener("orientationChange", lazyload);
                }
            }, 20);
        }

        document.addEventListener("scroll", lazyload);
        window.addEventListener("resize", lazyload);
        window.addEventListener("orientationChange", lazyload);

        // Call the function initially for first page load
        window.setTimeout(lazyload, 250);
    }
})

